
import React from 'react';
import { cn } from "@/lib/utils";

interface InterviewContainerProps {
  isReversed: boolean;
  intervieweeName: string;
  children: React.ReactNode;
}

const InterviewContainer = ({ isReversed, intervieweeName, children }: InterviewContainerProps) => {
  // Log to help debug the layout changes
  
  
  return (
    <article 
      className={cn(
        "bg-white rounded-lg shadow-sm p-4 md:p-6 mb-6 transition-all duration-300 animate-fade-in hover:shadow-md relative",
        // Apply border to the left or right side based on isReversed value
        isReversed ? "border-r-2 md:border-r-4" : "border-l-2 md:border-l-4",
        "border-[#ea384c]"
      )}
      role="article"
      aria-label={`Interview with ${intervieweeName}`}
    >
      {children}
    </article>
  );
};

export default InterviewContainer;
